<template>
    <div class="main-content">
        <the-header :title="t('Mail')"/>
        <nav-body :links="nav">
            <loading size="sm" v-if="loading === true"/>
            <titan-form :schema="schema"
                        :model="formData"
                        v-on:saveData="saveData()"
                        v-if="loading === false"
            />
        </nav-body>
    </div>
</template>
<script>
    import ManageTemplate from '../../../../admin/Pages/Templates/Manage'
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import NavBody from '../../../../admin/Layout/NavBody'
    import {admin} from '../Admin'

    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator"
    import Loading from '../../../../core/Components/loading'

    export default {
        mixins: [admin],
        components: {
            TheHeader,
            NavBody,
            ManageTemplate,
            Loading,
            TitanForm
        },
        created() {
            this.loadData();
        },
        methods: {
            saveData() {
                const formData = {...this.formData};
                formData.id = this.$route.params.id;

                this.$store.dispatch(
                    'mails/update',
                    formData
                ).then(response => {
                    this.$router.push({
                        name: 'mailAdmin',
                        params: {page: 1}
                    });
                });
            },
            loadData() {
                this.$store.dispatch('mails/get', this.$route.params.id).then(data => {
                    this.formData = data;
                    this.loading = false;
                });
            }
        },
        data() {
            return {
                loading: true,
                formData: {},
                schema: [
                    {
                        name: this.t('Update Mail'),
                        type: 'main',
                        fields: [
                            {
                                type: 'titanSwitch',
                                label: this.t('Resend'),
                                model: 'resend',
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Subject'),
                                model: 'subject',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('To'),
                                model: 'to',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('From'),
                                model: 'from',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'titanRedactor',
                                label: this.t('Text'),
                                model: 'body',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }
                        ]
                    }
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/admin/adminMail/Manage.vue